import axios from "axios";
import Api from './shared';
import { tokenInterceptor } from './tokenInterceptor';
import { IPublicClientApplication } from '@azure/msal-browser';
import { msalInstance }  from './appAD';

const api = Api;

const Logout = () => {
  msalInstance.logoutRedirect({
    postLogoutRedirectUri: window.location.origin
  });
};

api.interceptors.request.use(tokenInterceptor);

api.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      Logout();
      //  limpiar cocckies
      document.cookie = "";
      // limpiar local storage
      localStorage.removeItem('token');
      //limpiar session storage
      sessionStorage.clear();
      // redireccionar al login
      window.location.href = "/";
    }
    return Promise.reject(err);
  }
);

export default api;


// import Api from './shared';
// import tokenInterceptor from './tokenInterceptor';
// import ErrorHandler from "../services/ErrorHandler/ErrorHandler";
// import ErrorMessages from '../services/ErrorHandler/ErrorMessages';

// const appApi = Api;

// //envia el bearer token en cada request
// appApi.interceptors.request.use(tokenInterceptor);

// //maneja errores de autorizacion 401
// appApi.interceptors.response.use(
//   res => res,
//   err => {
//     const status = err.response?.status;
//      if (status === 401) {
//       //limpiar cocckies
//       document.cookie = "";
//       //limpiar local storage
//       // localStorage.removeItem('token');
//       //redireccionar al login
//       window.location.href = "/";
//       return;
//     }

//     if (status === 403) {
//       ErrorHandler.sendError(
//         new Error("Forbidden"),
//         ErrorMessages.Forbidden
//       );
//       return;
//     }

//     return Promise.reject(err);
//   }
// );


// // This is an example that may need to change for a specific sso solution
// // * this assume a json object returned that looks like this {"token": "...."}
// // * also you will need to change the url
// // const getAuthToken = async () => {
// //   const { data } = await appApi.get('/auth/token');

// //   if (data.token) {
// //     localStorage.setItem('token', data.token);
// //   }
// // };

// export default appApi;
// // export { getAuthToken };
